import { _ep0, _mw0, command } from "../commandBuilder";
import { GetCallerIdentity$ } from "../schemas/schemas_0";
export class GetCallerIdentityCommand extends command(_ep0, _mw0, "GetCallerIdentity", GetCallerIdentity$) {
}
